import { inject, Pipe, type PipeTransform } from '@angular/core';
import { DomSanitizer, type SafeUrl } from '@angular/platform-browser';

@Pipe({ name: 'safeUrl' })
export class SafeUrlPipe implements PipeTransform {
  private _sanitizer = inject(DomSanitizer);

  public transform(url: string): SafeUrl {
    return this._sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
